import { BUTTON_TYPES, INSERT_PLUGIN_BUTTONS, TOOLBARS } from 'wix-rich-content-editor-common';
import { DEFAULTS } from '../defaults.js';
import InsertPluginIcon from '../icons/InsertPluginIcon.js';
import '../constants.js';
import 'ricos-schema';
import '../types.js';
import 'react';

const createInsertButtons = ({
  t,
  settings,
  customTooltip
}) => {
  var _a, _b;
  const icon = ((_b = (_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) == null ? void 0 : _b.InsertPluginButtonIcon) || InsertPluginIcon;
  return [
    {
      type: BUTTON_TYPES.BUTTON,
      name: INSERT_PLUGIN_BUTTONS.BUTTON,
      tooltip: customTooltip || t("ButtonPlugin_InsertButton_Tooltip"),
      getIcon: () => icon,
      toolbars: [TOOLBARS.INSERT_PLUGIN, TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      componentData: DEFAULTS,
      section: "BlockToolbar_Section_Advanced"
    }
  ];
};

export { createInsertButtons as default };
//# sourceMappingURL=insert-buttons.js.map
